import { useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { useNavigation } from '@react-navigation/native';
import { handleDeepLinkAction } from '../js/deeplink';

/**
 * Custom hook to manage deep linking functionality
 * Handles navigation based on deep link parameters
 */
export const useDeepLink = () => {
    const dispatch = useDispatch();
    const navigation = useNavigation();

    const { renderApp, initAppLogout, redirectInfo, hotelListData } = useSelector(
        state => ({
            renderApp: state.appConfigSlice.renderApp,
            initAppLogout: state.appConfigSlice.initAppLogout,
            redirectInfo: state.deeplinkSlice.redirectInfo,
            hotelListData: state.hotelSelectorSlice.hotelListData
        }),
        shallowEqual
    );

    /**
     * Process deep link when app is ready and redirect info is available
     */
    useEffect(() => {
        if (renderApp && !initAppLogout && redirectInfo && Object.keys(redirectInfo)?.length > 0) {
            setTimeout(() => {
                dispatch(handleDeepLinkAction(redirectInfo, navigation));
            }, 500);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [renderApp, redirectInfo, hotelListData]);

    return null; // This hook only handles side effects
};
